import React, { useEffect, useState } from "react";
import { useFormContext } from "react-hook-form";
import { TextField, Grid } from "@material-ui/core";

import { Page } from "components";
import serviciosTablero from "utils/serviciosTablero";
import { Autocomplete } from "@material-ui/lab";
import { Controller } from "react-hook-form";
import { useStylesTablero } from "views/Tablero/utils/stylesTablero";
import InputAdornment from '@material-ui/core/InputAdornment';
import CalendarTodayIcon from '@material-ui/icons/CalendarToday';

const FormTablero = ({ ctls, defaultValue, ...props }) => {
  const classesTablero = useStylesTablero();
  const [cargando, setCargando] = useState(false);
  const [mensaje, setMensaje] = useState({ open: false });
  const { register, errors, setValue, control, getValues } = useFormContext();

  const cerrarMensaje = () => setMensaje({ open: false });

  useEffect(() => {
    if(defaultValue) {
      setValue("solicitud", defaultValue.solicitud?.idsolicitud || null);
      setValue("lider", defaultValue.lider?.idusuario || null);
    }
  }, []);

  return (
    <Page
      title="Tablero"
      className={{}}
      mensaje={{ ...mensaje, cerrar: cerrarMensaje }}
      cargando={cargando}
    >
      <Grid container spacing={1}>
        <Grid xs={6}>
          <TextField
            label="Nombre de tablero *"
            name="nombre"
            defaultValue={defaultValue?.titulo || ""}
            inputRef={register({
              required: { value: true, message: "Campo requerido" },
            })}
            variant="outlined"
            helperText={errors?.nombre?.message}
            error={errors?.nombre}
            className={classesTablero.field}
          />
        </Grid>
        {props?.action == "insert" && (
          <Grid xs={6}>
            <Controller
              control={control}
              name="participantes"
              {...register("participantes", {
                required: { value: false, message: "Campo requerido" },
              })}
              defaultValue={null}
              render={(props) => (
                <Autocomplete
                  multiple
                  id="tags-standard"
                  options={ctls?.nombres || []}
                  onChange={(event, item) => {
                    setValue("participantes", item.length > 0 ? item : null);
                  }}
                  getOptionLabel={(option) => option.nombre}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      label="Participantes"
                      name="participantesTxt"
                      helperText={
                        errors?.participantes?.message ||
                        "Por defecto el usuario creador es participante"
                      }
                      error={errors?.participantes}
                      className={classesTablero.field}
                    />
                  )}
                />
              )}
            />
          </Grid>
        )}
        <Grid xs={12} style={{ marginTop: "20px" }}>
          <Controller
            control={control}
            name="solicitud"
            // {...register("solicitud", {
            //   required: { value: false, message: "Campo requerido" },
            // })}
            defaultValue={defaultValue?.solicitud || null}
            render={(props) => (
              <Autocomplete
                id="tags-solicitud"
                options={ctls?.solicitudes || []}
                onChange={(event, item) => {
                  setValue("solicitud", item?.idsolicitud || null);
                }}
                getOptionLabel={(option) =>
                  option.titulo + " - " + option.sistema
                }
                defaultValue={defaultValue?.solicitud || null}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    label="Asignar solicitud"
                    name="solicitudTxt"
                    helperText={errors?.solicitud?.message}
                    error={errors?.solicitud}
                    className={classesTablero.field}
                  />
                )}
              />
            )}
          />
        </Grid>
        <Grid xs={12} style={{ marginTop: "20px" }}>
          <Controller
            control={control}
            name="lider"
            {...register("lider", {
              required: {
                value: props.action == "update" ? false : false,
                message: "Campo requerido",
              },
            })}
            defaultValue={defaultValue?.lider || null}
            render={(props) => (
              <Autocomplete
                id="tags-lider"
                options={ctls?.nombres || []}
                onChange={(event, item) => {
                  setValue("lider", item?.idusuario || null);
                }}
                getOptionLabel={(option) => option.nombre}
                defaultValue={defaultValue?.lider || null}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    label="Asignar líder"
                    name="liderTxt"
                    helperText={
                      errors?.lider?.message ||
                      "Por defecto el usuario creador sera asignado como lider"
                    }
                    error={errors?.lider}
                    className={classesTablero.field}
                  />
                )}
              />
            )}
          />
        </Grid>
        <Grid xs={12} style={{ margin: "15px 0 20px 0", fontFamily: "Arial" }}>
          Asignación de fechas (opcional)
        </Grid>
        <Grid xs={6}>
          <TextField
            label="Fecha de inicio"
            name="finicio"
            defaultValue={defaultValue?.finicio || null}
            inputRef={register({
              required: { value: false, message: "Campo requerido" },
            })}
            variant="outlined"
            type="date"
            helperText={errors?.finicio?.message}
            error={errors?.finicio}
            InputLabelProps={{ shrink: true }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <CalendarTodayIcon />
                </InputAdornment>
              ),
            }}
            className={classesTablero.field}
          />
        </Grid>
        <Grid xs={6}>
          <TextField
            label="Fecha de finalización"
            name="ffin"
            defaultValue={defaultValue?.ffin || null}
            className={classesTablero.field}
            inputRef={register({
              required: {
                value: getValues("finicio") ? true : false,
                message: "Campo requerido",
              },
            })}
            variant="outlined"
            type="date"
            helperText={errors?.ffin?.message}
            error={errors?.ffin}
            InputLabelProps={{ shrink: true }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <CalendarTodayIcon />
                </InputAdornment>
              ),
            }}
          />
        </Grid>
      </Grid>
    </Page>
  );
};

export default FormTablero;
